import React from 'react';
import PropTypes from 'prop-types';
import { FiExternalLink } from 'react-icons/fi';
import styles from './buttonSection.module.css';

const ButtonSectionCard = ({ icon, text, rightClick, tedUrl, showTed, hideAll }) => {
    const hasTedUrl = typeof tedUrl === 'string' && tedUrl.trim().length > 0;

    const handleNavigate = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (hasTedUrl) window.open(tedUrl, '_blank', 'noopener,noreferrer');
    };

    // combine incoming showTed prop with the presence of a valid URL
    const shouldShowTed = Boolean(showTed) && hasTedUrl;

    return (
        <div className={styles.button_section}>
            {
                hideAll ?
                <div style={{ height: '24px', width: '100%' }}></div> :
                <>
                    {shouldShowTed && (
                        <div className={styles.button_wrapper} onClick={handleNavigate}>
                            <div className={styles.button_text} style={{ marginRight: '8px' }}>View in TED</div>
                            <FiExternalLink className={styles.button_right_icon} />
                        </div>
                    )}
                    {text && (
                        <div className={styles.button_wrapper} onClick={rightClick}>
                            <div className={styles.button_text}>{text}</div>
                            <div className={styles.button_right_icon}>{icon}</div>
                        </div>
                    )}
                </>
            }
        </div>
    );
}

ButtonSectionCard.propTypes = {
    text: PropTypes.string,
    icon: PropTypes.node,
    rightClick: PropTypes.func,
    tedUrl: PropTypes.string,
    showTed: PropTypes.bool,
    hideAll: PropTypes.bool
}

ButtonSectionCard.defaultProps = {
    showTed: true,
    hideAll: false,
};

export default ButtonSectionCard;
